export const laceOfKnots = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color

  // 上＿左
  ctx.beginPath()
  ctx.moveTo(432, 69) // 左
  ctx.quadraticCurveTo(445, 69, 448, 69) // 左右
  ctx.quadraticCurveTo(465, 59, 465, 59) // 右上右
  ctx.quadraticCurveTo(466, 54, 459, 50) // 右上左
  ctx.quadraticCurveTo(432, 69, 432, 69) // 左
  ctx.fill()
  ctx.moveTo(464, 56) // 右上
  ctx.quadraticCurveTo(444, 68, 444, 68) // 左右
  ctx.stroke()
  ctx.closePath()

  // 上＿右
  ctx.beginPath()
  ctx.moveTo(499, 68) // 左
  ctx.quadraticCurveTo(524, 73, 524, 73) // 左右
  ctx.quadraticCurveTo(550, 62, 550, 62) // 右上右
  ctx.quadraticCurveTo(553, 61, 548, 52) // 右上左
  ctx.quadraticCurveTo(499, 68, 499, 68) // 左
  ctx.fill()
  ctx.moveTo(551, 59) // 右上
  ctx.quadraticCurveTo(518, 71, 518, 74) // 左右
  ctx.stroke()
  ctx.closePath()

  // 右下
  ctx.beginPath()
  ctx.moveTo(705, 460) // 左上
  ctx.quadraticCurveTo(701, 481, 705, 508) // 左下
  ctx.quadraticCurveTo(715, 508, 715, 508) // 右下
  ctx.quadraticCurveTo(714, 459, 714, 459) // 右上
  ctx.quadraticCurveTo(703, 460, 705, 460) // 左上
  ctx.fill()
  ctx.moveTo(713, 462) // 上
  ctx.quadraticCurveTo(710, 484, 715, 508) // 左下
  ctx.stroke()
  ctx.closePath()

  // // 左＿上
  // ctx.beginPath()
  // ctx.moveTo(705, 460) // 左上
  // ctx.quadraticCurveTo(701, 481, 705, 508) // 左下
  // ctx.quadraticCurveTo(715, 508, 715, 508) // 右下
  // ctx.quadraticCurveTo(714, 459, 714, 459) // 右上
  // ctx.quadraticCurveTo(703, 460, 705, 460) // 左上
  // ctx.fill()
  // ctx.moveTo(713, 462) // 上
  // ctx.quadraticCurveTo(710, 484, 715, 508) // 左下
  // ctx.stroke()
  // ctx.closePath()

  // 左＿下
  ctx.beginPath()
  ctx.moveTo(93, 414) // 左＿左下
  ctx.quadraticCurveTo(129, 442, 150, 442) // 右下
  ctx.quadraticCurveTo(150, 429, 150, 429) // 右上
  ctx.quadraticCurveTo(130, 430, 100, 405) // 左＿左上
  ctx.quadraticCurveTo(93, 414, 93, 414) // 左＿左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 結び玉↓
  ctx.beginPath()
  ctx.moveTo(149, 430) // 左上
  ctx.quadraticCurveTo(145, 440, 152, 444) // 左下
  ctx.quadraticCurveTo(160, 446, 163, 439) // 右下
  ctx.quadraticCurveTo(156, 429, 156, 429) // 右上
  ctx.quadraticCurveTo(152, 426, 149, 430) // 左上
  ctx.fill()
  ctx.moveTo(156, 428) // 上
  ctx.quadraticCurveTo(152, 438, 159, 442) // 下
  ctx.stroke()
  ctx.closePath()
}
